import type { ThemeMode } from './preference';

declare global {
  interface Window {
    finishSpaStartup?: () => void;
  }
}

// This self-contained function also runs inline before fonts and the application
// bundle. Keep dependencies out of its body so it works when the bundle fails.
export function initializeStartup(mode: ThemeMode): void {
  const root = document.documentElement;
  root.dataset.themeMode = mode;
  root.dataset.spaStartup = 'loading';
  const timer = window.setTimeout(() => {
    root.dataset.spaStartup = 'slow';
  }, 4000);
  const onEntryError = (event: Event): void => {
    const source = event.target instanceof HTMLScriptElement ? event.target.src
      : event instanceof ErrorEvent ? event.filename : '';
    if (/\/(?:assets\/javascript\/main-router\.tsx|js\/main-router-bundle\.js)(?:[?#]|$)/.test(source)) {
      root.dataset.spaStartup = 'failed';
      window.clearTimeout(timer);
    }
  };
  window.addEventListener('error', onEntryError, true);
  window.finishSpaStartup = () => {
    window.clearTimeout(timer);
    window.removeEventListener('error', onEntryError, true);
    root.dataset.spaStartup = 'ready';
    delete window.finishSpaStartup;
  };
}

export function finishStartup(): void {
  window.finishSpaStartup?.();
}
